import React from 'react';
import s from './Headphone.module.css';
import Ribbon from '../../components/Ribbon/Ribbon';
import ProductCard from '../../components/ProductCard/ProductCard';
import headphone from '../../JSON/headphone.json';
import ProductCardHero from '../../components/ProductCardHero/ProductCardHero';
import Container from '../../components/Container/Container';

export default function Headphone() {
  return (
    <div className={s.ProductsPage}>
      <ProductCardHero
        text={'Гарнітура GamePRO – відчуй повноту занурення'}
        title={headphone[0].title}
        sendUrl={'/Images/ProductCardHeroBackgroundImages/headphone.png'}
      />
      <Ribbon />
      <Container>
        <div className={s.ProductsListDescription}>
          <h2 className={s.ProductsPageTitle}>Ігрові гарнітури</h2>
          <p className={s.ProductsPageText}>
            Зручний і міцний, але, перш за все, оптимізований для забезпечення
            чудової якості звуку і мікрофона. Саме так ми проектуємо кожну з
            наших гарнітур. У нашому асортименті є все, від навушників-вкладишів
            до навушників-вкладишів, включаючи 7.1, стерео і мобільні варіанти.
          </p>
        </div>

        <div className={s.ProductsList}>
          <ProductCard products={headphone} />
        </div>
      </Container>
    </div>
  );
}
